export const JSONDecode = (data: string) => (data ? JSON.parse(data) : null)
